<template lang="html">
  <div class="noValidation">
        <router-view/>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.noValidation {
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
